import { GiantHeadline, Reveal, SlideTop } from "../presentation";

export default function S12PressKits() {
  return (
    <section id="press-kits" className="sec theme-dark" data-testid="slide-press-kits">
      <div className="sec-container">
        <SlideTop ch="09" label="for the press" testid="press-chapter" />

        <div className="press-grid">
          <div>
            <div className="sec-head">
              <Reveal><span className="eyebrow">.everything you need</span></Reveal>
            </div>
            <GiantHeadline line1="PRESS" line2="KIT" accentLine={2} testid="press-giant" />
            <Reveal delay={2}>
              <p className="editorial" style={{ maxWidth: "34ch", marginTop: "clamp(32px, 4vw, 56px)" }} data-testid="press-lede">
                Imagery, specifications and releases. <span className="gold">Scan to download.</span>
              </p>
            </Reveal>
            <Reveal delay={3} style={{ marginTop: "clamp(24px, 3vw, 40px)" }}>
              <a
                className="pill"
                href="https://sunreef-yachts.com"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="press-link"
              >
                sunreef-yachts.com <span className="arrow">→</span>
              </a>
            </Reveal>
          </div>

          <Reveal className="press-qr" delay={2} testid="press-qr">
            <div className="qr-frame qr-frame-real" data-testid="press-qr-frame">
              <img
                className="qr-img"
                src="https://customer-assets-jai6qajn.emergentagent.net/job_5ef9df75-b51e-4290-85d0-a251c4ec8afa/artifacts/wazdosb9_f662a5de-749d-4944-a6f9-f43983889683.jpeg"
                alt="Press kit QR code"
                data-testid="press-qr-img"
              />
              <span className="ph-note">Take a photo. Save it for later.</span>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
